import React from 'react';

import { MissingContent } from '~constants/notFoundMap';

import Icon from '~components/icon';

interface ComponentProps {
  content: MissingContent;
}

const PageNotFound: React.FC<ComponentProps> = ({ content }) => {
  const { header, descriptor, icon } = content;

  return (
    <div className="page-not-found" data-cy="page-not-found">
      <Icon icon={icon} size="4x" />
      <h1 className="mt-4">{header}</h1>
      <p className="mt-4">{descriptor}</p>
    </div>
  );
};

export default PageNotFound;
